<img
  class="w-full h-full object-cover"
  [src]="config?.photoUrl || 'assets/avatar.svg'"
  [class.group-active:opacity-75]="config?.routerLink"
/>
